import { Outlet, createRootRoute } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ThemeProvider } from '@/components/theme-provider'
// @ts-expect-error - Styles are handled by bundler
import '../styles.css'
import { LogicNextNavbar } from '@/components/logic-next-navbar'
import StarsBackground from '@/components/StarsBackground'
import Footer from '@/components/sections/Footer'
import ErrorBoundary from '@/components/ErrorBoundary'

// Lazy load LiquidEther for performance, though currently it is imported directly in index due to debugging issues.
// Reverting to direct import based on user's successful build state, or keeping lazy if preferred.
// Given previous context of "Import directly for debugging", I will try lazy again but with the fix (ErrorBoundary + correct imports).
// Actually, to be safe and consistent with the user's working state, I will use the lazy import logic but carefully.
// User's index.tsx had: import LiquidEther from '../components/LiquidEther' // Import directly for debugging
// I will use direct import to match their stable state.
import LiquidEther from '@/components/LiquidEther'

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  return (
    <ThemeProvider defaultTheme="dark">
      <div className="min-h-screen bg-transparent text-white selection:bg-indigo-500/30 overflow-x-hidden font-sans">
        {' '}
        {/* Global Background Layers */}
        <div className="fixed inset-0 pointer-events-none">
          {/* Stars background (z-0) */}
          <div className="absolute inset-0 z-0 overflow-hidden">
            <StarsBackground speed={50} starColor="#fff" />
          </div>

          {/* Liquid Ether (z-1) - slightly above stars but behind content */}
          <div className="absolute inset-0 z-1 overflow-hidden">
            <ErrorBoundary
              fallback={<div className="w-full h-full bg-slate-900/50" />}
            >
              <LiquidEther
                colors={['#5227FF', '#FF9FFC', '#B19EEF']}
                mouseForce={20}
                cursorSize={100}
                isViscous={false}
                viscous={30}
                iterationsViscous={32}
                iterationsPoisson={32}
                resolution={0.5}
                isBounce={false}
                autoDemo={true}
                autoSpeed={0.5}
                autoIntensity={2.2}
                takeoverDuration={0.25}
                autoResumeDelay={3000}
                autoRampDuration={0.6}
                style={{ width: '100%', height: '100%' }}
              />
            </ErrorBoundary>
          </div>
        </div>
        {/* Navbar (Fixed z-50) */}
        <LogicNextNavbar />
        {/* Page Content (Relative z-10 to sit above background) */}
        <div className="relative z-10 flex flex-col min-h-screen">
          <div className="grow">
            <Outlet />
          </div>
          <Footer />
        </div>
        {/* Devtools */}
        {import.meta.env?.DEV && <TanStackRouterDevtools />}
        {import.meta.env?.DEV && <ReactQueryDevtools />}
      </div>
    </ThemeProvider>
  )
}
